import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GridApi, ColDef, GridReadyEvent, PaginationChangedEvent } from 'ag-grid-community';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';
import { MerchantService } from '../merchant.service';
import { environment } from 'src/environments/environment';

const {defaultPageSizeArr, defaultPageSize} = environment;

@Component({
  selector: 'app-device-management',
  templateUrl: './device-management.component.html',
  styleUrls: ['./device-management.component.scss']
})
export class DeviceManagementComponent implements OnInit {

  
    permissions :any;
    merchantId : any;
    private gridApi: GridApi;
    saveData : any;
    public pageSize: number = defaultPageSize;
    public pageSizeArr: any = defaultPageSizeArr;
    totalRecords: any;
    currentPage: number = 1;
    collectionSize: number = 0;
    public defaultColDef: ColDef = {
      flex: 1,
      resizable: true,
    };
    public columnDefs: ColDef[] = [
        { field: 'imageUrl',lockVisible:true, sortable: false , headerName: 'Icon', cellClass: 'grid-cell-centered',cellRenderer: (params: any) => {
            return params.data.isLoading ? `<span class="spinner-border spinner-border-sm"></span>` : `<img src="${params.value}" width="40" height="30"/>`;
          },
          onCellClicked: (eve: any) => {
          }
        },
        { field: 'terminalId',lockVisible:true,  headerName: 'Terminal ID', editable:false },
        { field: 'serialNumber',lockVisible:true, headerName: 'Serial Number', editable:false},
        { field: 'deviceType',lockVisible:true, headerName: 'Device Type', editable:false},
        { field: 'status',lockVisible:true, headerName: 'Status', editable:false},
      ];
  
    public columnCommission: ColDef[] = [...this.columnDefs];
    tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  
    constructor(private router: Router,private menuService: MenusService,private location:Location,private merchantService: MerchantService,private alertService : AlertService, private route: ActivatedRoute) { }
  
    async ngOnInit(){
      this.merchantId = this.route.snapshot.queryParamMap.get("mid");
      const path = this.location.prepareExternalUrl(this.location.path());
      this.permissions = this.menuService.getPermissions(path);
      console.log(this.permissions);
      if (this.permissions == null || this.permissions == '' || !this.permissions) {
        this.alertService.errorAlert({
          title: "No Access",
          backdrop: true,
          toast: true,
          timer: 1500
        })
        await this.router.navigateByUrl('/');
      }
      this.getDeviceList();
    }
  
    getDeviceList(){
      this.merchantService.getDeviceList(this.merchantId).subscribe((response:any)=>{
      console.log(response)
      response.response.data.map((_: any, i: number) => {
          setTimeout(() => {
            this.imageCellRenderer(_.imageUrl, i);
          }, 200);
        })
        this.saveData = response.response.data;
      })
    }

    imageCellRenderer(url: any, indVal: number) {
      console.log(url)
      this.merchantService.getPOSImage(url).subscribe(
        (data: any) => {
          console.log(data);
          if(this.saveData[indVal]){
            this.saveData[indVal].isLoading = false;
            if (data.type == 'image/png'|| data.type == 'image/jpeg') {
              const blobUrl = URL.createObjectURL(data);
              this.saveData[indVal].imageUrl = blobUrl;
            } else {
              this.saveData[indVal].imageUrl = 'assets/images/product.png';
            }
            this.gridApi.applyTransaction({ update: [this.saveData[indVal]] });
        }
      
        }, err => {
          if(this.saveData[indVal]){
            this.saveData[indVal].isLoading = false;
            this.saveData[indVal].imageUrl = 'assets/images/product.png';
            this.gridApi.applyTransaction({ update: [this.saveData[indVal]] });
          }
        }
      )
    }

    onGridReady(params: GridReadyEvent<any>) {      
    this.gridApi = params.api
    }

    onPageSizeChanges($event: Event) {
        this.gridApi.paginationSetPageSize(this.pageSize)
        this.gridApi.applyTransaction({remove: this.saveData})
        this.gridApi.showLoadingOverlay();
    
        this.merchantService.getDeviceList(this.merchantId)
          .subscribe((response) => {
            // this.collectiondata = response.content
            // this.collectionSize=data.totalElements
            // this.totalRecords =  data.content
             this.gridApi.applyTransaction({add: this.saveData})});
    }

    onPaginationChange(param: PaginationChangedEvent | any) {
        this.gridApi.applyTransaction({remove: this.saveData})
        this.gridApi.showLoadingOverlay();
        this.merchantService.getDeviceList(this.merchantId)
          .subscribe((response) => {
            // this.collectiondata = response.content
            // this.collectionSize=data.totalElements
            // this.totalRecords =  data.content
             this.gridApi.applyTransaction({add: this.saveData})});
      }
    
}
